import React from 'react';
export function Timeline() {
  const milestones = [{
    year: '1960',
    title: 'The Beginning',
    description: 'Jeremiah Kiboya purchases the land in Nyandarua after independence.'
  }, {
    year: '1970',
    title: 'Award Winning',
    description: 'The farm receives multiple agricultural awards for excellence.'
  }, {
    year: '1980',
    title: 'Expansion',
    description: 'First major expansion of the dairy herd and crop fields.'
  }, {
    year: '1999',
    title: 'Modernization',
    description: 'Introduction of new farming techniques and infrastructure.'
  }, {
    year: '2008',
    title: 'New Generation',
    description: 'Focus shifts to sustainable practices and community integration.'
  }, {
    year: '2020',
    title: 'Digital Era',
    description: 'Adopting technology for better herd management and monitoring.'
  }, {
    year: '2027',
    title: 'The Dream',
    description: 'Vision for a fully integrated, self-sustaining pedigree farm.'
  }];
  return <section id="story" className="py-20 bg-stone-50 overflow-hidden" data-id="element-359">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-360">
        <div className="text-center mb-16" data-id="element-361">
          <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4" data-id="element-362">
            Our Journey
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-363">
            From humble beginnings to a vision of the future. The story of
            GreenSlopes Farm is one of resilience, growth, and family.
          </p>
        </div>

        <div className="relative" data-id="element-364">
          {/* Vertical Line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-green-200" data-id="element-365"></div>

          <div className="space-y-12" data-id="element-366">
            {milestones.map((milestone, index) => <div key={milestone.year} className={`flex items-center justify-between w-full ${index % 2 === 0 ? 'flex-row-reverse' : ''}`} data-id="element-367">
                <div className="w-5/12" data-id="element-368"></div>

                <div className="z-10 flex items-center justify-center w-12 h-12 bg-green-600 rounded-full border-4 border-white shadow-lg shrink-0" data-id="element-369">
                  <div className="w-3 h-3 bg-white rounded-full" data-id="element-370"></div>
                </div>

                <div className="w-5/12" data-id="element-371">
                  <div className={`p-6 bg-white rounded-xl shadow-md border-l-4 ${index % 2 === 0 ? 'border-green-500 text-right' : 'border-amber-500 text-left'} hover:shadow-lg transition-shadow`} data-id="element-372">
                    <span className="inline-block px-3 py-1 bg-green-50 text-green-800 text-sm font-bold rounded-full mb-2" data-id="element-373">
                      {milestone.year}
                    </span>
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-374">
                      {milestone.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-375">
                      {milestone.description}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}